import { JWTPayload, getJWTPayload } from "@/getinfo-api/auth";
interface IJWTTokenObject {
  accessToken: string;
  refreshToken: string;
}
enum tokenMode {
  development = "auth-tokens-development",
  production = "auth-tokens-production"
}

let token = {
  get isTokenExist(): boolean {
    return (
      !!localStorage.getItem(tokenMode.development) ||
      !!localStorage.getItem(tokenMode.production)
    );
  },

  get currentToken(): IJWTTokenObject | undefined {
    const selectToken = this.isTokenExist
      ? localStorage.getItem(tokenMode.development) ||
        localStorage.getItem(tokenMode.production)
      : undefined;

    return selectToken ? JSON.parse(selectToken) : undefined;
  },

  get tokenPayload(): JWTPayload | undefined {
    return getJWTPayload();
  },

  get isTokenExpired(): boolean {
    let result = false;

    if (this.tokenPayload) {
      const expired = this.tokenPayload
        ? this.tokenPayload?.exp * 1000
        : undefined;
      const now = new Date(
        "Thu Jan 27 2020 10:10:45 GMT+0400 (Samara Standard Time)"
      ).getTime();
      result = expired ? expired > now : false;
    }

    return result;
  }
};

export { token };
